import { useRef } from 'react';

export const useDelayedFn = <TArgs extends unknown[] = []>(
  fn: (...args: TArgs) => void,
  delayMS: number
) => {
  const timeoutId = useRef<ReturnType<typeof setTimeout> | null>(null);

  const callFn = (...args: TArgs) => {
    if (timeoutId.current) {
      clearTimeout(timeoutId.current);
    }
    timeoutId.current = setTimeout(() => {
      fn(...args);
      timeoutId.current = null;
    }, delayMS);
  };

  const cancel = () => {
    if (timeoutId.current) {
      clearTimeout(timeoutId.current);
      timeoutId.current = null;
    }
  };

  return [callFn, cancel] as const;
};
